// extracted by css-extract-rspack-plugin
export default {"cls1":"Loading-cls1_QIx","cls2":"Loading-cls2_CH9 Loading-cls1_QIx"};